"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECHARGE_IMPORTS_TABS = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var get_1 = __importDefault(require("lodash/fp/get"));
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var DropdownWithExpandBtn_1 = __importDefault(require("atomicComponents/organisms/Dropdown/DropdownWithExpandBtn"));
var TabbedStackLayout_1 = __importDefault(require("atomicComponents/organisms/Layout/TabbedStackLayout"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FilteredTable_1 = __importDefault(require("containers/TableMaker/FilteredTable"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var filter_1 = require("utils/filter");
var UploadCustomCsv_1 = __importDefault(require("./Modals/UploadCustomCsv"));
var tableConf_1 = __importDefault(require("./tableConf"));
exports.RECHARGE_IMPORTS_TABS = [
    { label: 'For Review', href: '/recharges/imports/for-review' },
    { label: 'All', href: '/recharges/imports/all' },
];
var FILTER_MAP = {
    'for-review': function (rechImport) { var _a; return (_a = rechImport.uploadRequirements) === null || _a === void 0 ? void 0 : _a.needsUpload; },
    all: function () { return true; },
};
var Table = (0, FilteredTable_1.default)(tableConf_1.default, [(0, filter_1.makeGroupDef)('Vendor', function (item) { var _a, _b; return (_b = (_a = item.rechVendor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'No vendor'; })], [(0, get_1.default)('rechVendor.name'), (0, get_1.default)('number'), function (item) { return item.date && (0, end2end_1.getDateNice)(item.date); }]);
var Imports = function () {
    var _a = __read((0, react_1.useState)(false), 2), customCsvModalOpen = _a[0], customImportModalOpen = _a[1];
    var filterKey = (0, react_router_dom_1.useParams)().filterKey;
    var filterFn = (0, react_1.useMemo)(function () {
        var filterImport = filterKey && FILTER_MAP[filterKey];
        return function (rIs) { return filterImport ? rIs === null || rIs === void 0 ? void 0 : rIs.filter(filterImport) : rIs; };
    }, [filterKey]);
    return ((0, jsx_runtime_1.jsxs)(TabbedStackLayout_1.default, __assign({ tabs: exports.RECHARGE_IMPORTS_TABS }, { children: [customCsvModalOpen && (0, jsx_runtime_1.jsx)(UploadCustomCsv_1.default, { onClose: function () { return customImportModalOpen(false); } }), (0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Imports", description: "Recharges - Imports" }), (0, jsx_runtime_1.jsx)(Table, { filterFunction: filterFn, toolbarContent: {
                    post: ((0, jsx_runtime_1.jsx)(DropdownWithExpandBtn_1.default, __assign({ closeOnClick: true }, { children: (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Custom CSV Import", onClick: function () { return customImportModalOpen(true); } }) }))),
                }, toolbarProps: { width: 750 } })] })));
};
exports.default = Imports;
